import { render } from "./mat-list-item.vue?vue&type=template&id=ddd8e7c0&scoped=true&lang=true"
import script from "./mat-list-item.vue?vue&type=script&lang=js"
export * from "./mat-list-item.vue?vue&type=script&lang=js"

import "./mat-list-item.vue?vue&type=style&index=0&id=ddd8e7c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd8e7c0"]])

export default __exports__